/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Type_DefaultInputs */

const en_new_project_type_default = /** @type {(inputs: New_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

const fr_new_project_type_default = /** @type {(inputs: New_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par defaut`)
};

const de_new_project_type_default = /** @type {(inputs: New_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

const it_new_project_type_default = /** @type {(inputs: New_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinito`)
};

const ru_new_project_type_default = /** @type {(inputs: New_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По умолчанию`)
};

const es_new_project_type_default = /** @type {(inputs: New_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por defecto`)
};

const zh_cn2_new_project_type_default = /** @type {(inputs: New_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`默认`)
};

const ja_new_project_type_default = /** @type {(inputs: New_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デフォルト`)
};

const hi_new_project_type_default = /** @type {(inputs: New_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गलती करना`)
};

const pt_pt2_new_project_type_default = /** @type {(inputs: New_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padrão`)
};

/**
* | output |
* | --- |
* | "Default" |
*
* @param {New_Project_Type_DefaultInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_type_default = /** @type {((inputs?: New_Project_Type_DefaultInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Type_DefaultInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_type_default(inputs)
	if (locale === "de") return de_new_project_type_default(inputs)
	if (locale === "it") return it_new_project_type_default(inputs)
	if (locale === "ru") return ru_new_project_type_default(inputs)
	if (locale === "es") return es_new_project_type_default(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_type_default(inputs)
	if (locale === "ja") return ja_new_project_type_default(inputs)
	if (locale === "hi") return hi_new_project_type_default(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_type_default(inputs)
	return en_new_project_type_default(inputs)
});